/* Make It Personal - Theme JS */

document.addEventListener('DOMContentLoaded', () => {

  /* ---- MOBILE MENU ---- */
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('open');
    });
  }

  /* ---- SEARCH PANEL ---- */
  const searchToggle = document.querySelector('.search-toggle');
  const searchPanel = document.getElementById('search-panel');
  const searchClose = document.getElementById('search-close');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', () => {
      searchPanel.style.display = searchPanel.style.display === 'block' ? 'none' : 'block';
      if (searchPanel.style.display === 'block') {
        searchPanel.querySelector('.search-input').focus();
      }
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', () => {
      searchPanel.style.display = 'none';
    });
  }

  /* ---- STICKY HEADER SHADOW ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.08)' : 'none';
    }, { passive: true });
  }

  /* ---- CART COUNT UPDATE ---- */
  function updateCartCount(count) {
    const el = document.getElementById('cart-count');
    if (el) el.textContent = count;
  }

  /* ---- ADD TO CART AJAX ---- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('.btn-atc');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(productForm);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartCount(cart.item_count);
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = 'Error - Try Again';
          btn.disabled = false;
        }
      } catch {
        btn.textContent = 'Error - Try Again';
        btn.disabled = false;
      }
    });
  }

  /* ---- CART PAGE QUANTITY ---- */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const qtyEl = btn.closest('.qty-wrap').querySelector('.qty-display');
      let qty = parseInt(qtyEl.textContent);
      qty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) window.location.reload();
    });
  });

  /* ---- DISCOUNT CODE ---- */
  const discountApply = document.querySelector('.discount-apply');
  if (discountApply) {
    discountApply.addEventListener('click', async () => {
      const input = document.querySelector('.discount-input');
      if (!input || !input.value.trim()) return;
      const code = input.value.trim();
      const res = await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
      if (res.ok) {
        window.location.reload();
      }
    });
  }

  /* ---- SMOOTH ANCHOR SCROLL ---- */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- MEGA MENU CLICK SUPPORT ---- */
  const megaItem = document.querySelector('.has-mega');
  const megaMenu = document.querySelector('.mega-menu');
  if (megaItem && megaMenu) {
    // Keep open on click as well as hover for touch/tablet
    megaItem.addEventListener('click', (e) => {
      if (e.target.closest('.mega-menu')) return;
      megaMenu.classList.toggle('mega-open');
    });
    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!megaItem.contains(e.target)) {
        megaMenu.classList.remove('mega-open');
      }
    });
  }

});